<style lang="scss">
  .save-contact-view {
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: rgba(#1c1c25, 0.75);
    flex: 1;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 12px;
      flex: 1;

      :global(input) {
        color: white;
      }
    }

    .buttons {
      display: flex;
      flex-direction: row;
      gap: 6px;
      justify-content: flex-end;
    }
  }
</style>

<script>
  import TextInput from "../../../../../../svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import Button from "../../../../../../svelte-design-system/components/atoms/Button.svelte";
  import { diallerState } from "../diallerState.svelte";
  import { attendeesState } from "../attendeesState.svelte";
  import { showToast } from "../../../../../assets/js/src/general/utils";

  let firstName = $state("");
  let phone = $state(attendeesState.candidate.phone);
  let email = $state("");

  const handleCancel = () => {
    diallerState.viewMode = "user";
  };

  const handleSave = async () => {
    try {
      await diallerState.createCandidate(firstName, email, phone);
      diallerState.viewMode = "user";
      diallerState.showSaveContactNotification();
    } catch (error) {
      console.error(error);
      showToast({
        title: "Error",
        subtitle: "Failed to create candidate",
        type: "error",
      });
    }
  };
</script>

<div class="save-contact-view">
  <div class="inputs">
    <TextInput
      bind:value={firstName}
      placeholder="Name"
      size="large"
      wrapperStyle="background-color: #363636;"
    />

    <TextInput
      bind:value={phone}
      placeholder="Phone"
      size="large"
      readonly={true}
      wrapperStyle="background-color: #363636; opacity: 0.5;"
    />

    <TextInput
      bind:value={email}
      placeholder="Email"
      size="large"
      wrapperStyle="background-color: #363636;"
    />
  </div>

  <div class="buttons">
    <Button kind="ghost-blue" size="large" onclick={handleCancel}>Cancel</Button
    >
    <Button kind="primary" size="large" onclick={handleSave}>Save</Button>
  </div>
</div>
